import { AbstractControl, FormGroup, ValidationErrors } from "@angular/forms";

export class FormUtils {

  private static readonly errorMessages: { [key: string]: (error: any) => string } = {
    required: () => 'El campo es obligatorio',
    email: () => 'Ingrese un correo electrónico válido',
    pattern: () => 'El formato ingresado no es válido',
    minlength: (error) => `Mínimo ${error.requiredLength} caracteres`,
    maxlength: (error) => `Máximo ${error.requiredLength} caracteres`,
    min: (error) => `El valor mínimo es ${error.min}`,
    max: (error) => `El valor máximo es ${error.max}`,
    noUpperCase: () => 'La contraseña debe tener al menos una letra mayúscula.',
    noLowerCase: () => 'La contraseña debe tener al menos una letra minúscula.',
    noNumber: () => 'La contraseña debe tener al menos un número.',
    noSymbol: () => 'La contraseña debe tener al menos un símbolo.'
  };

  static getErrorMessage(control: AbstractControl | null, isFormSubmitted: boolean = false): string {
    if (!control || !control.errors) {
      return '';
    }
  
    if (!control.touched && !isFormSubmitted) {
      return '';
    }

    const errorKey = Object.keys(control.errors)[0];
    const errorValue = control.errors[errorKey];
    const messageFn = this.errorMessages[errorKey];

    return messageFn ? messageFn(errorValue) : 'Campo inválido';
  }

  public static toFormData(obj: Record<string, any>): FormData {
    const formData = new FormData();

    Object.entries(obj).forEach(([key, value]) => {
      if (value === null || value === undefined) return;

      if (value instanceof File || value instanceof Blob) {
        formData.append(key, value);
      } else if (Array.isArray(value)) {
        // Si es un array, agregar cada elemento por separado
        value.forEach(item => {
          if (item !== null && item !== undefined) {
            formData.append(key, item.toString());
          }
        });
      } else {
        formData.append(key, value.toString());
      }
    });

    return formData;
  }

  // Validaciones para contraseña
  static minLengthValidator(minLength: number) {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) return null;
      return value.length >= minLength ? null : { minLength: { requiredLength: minLength } };
    };
  }

  static hasUpperCaseValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) return null;
    return /[A-Z]/.test(value) ? null : { noUpperCase: true };
  }

  static hasLowerCaseValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) return null;
    return /[a-z]/.test(value) ? null : { noLowerCase: true };
  }

  static hasNumberValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) return null;
    return /\d/.test(value) ? null : { noNumber: true };
  }

  static hasSymbolValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) return null;
    return /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(value) ? null : { noSymbol: true };
  }
}
